import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackMortgageBrokerBannerClick, trackMortgageBrokerBannerShow } from './tracking';
import { configSelector } from '../../../selectors/configSelector';
import { MortgageBrokerBanner } from '../../components/MortgageBrokerBanner';
import { getJsonQuery } from 'shared/selectors/getJsonQuery';

/**
 * Баннер "Циан.Ипотека для профи"
 */
export const MortgageBrokerBannerContainer = () => {
  const config = useSelector(configSelector);
  const url = config.get<string>('mortgage-broker-application-frontend.promoUrl') || '';
  const jsonQuery = useSelector(getJsonQuery);

  const handleClick = React.useCallback(() => {
    trackMortgageBrokerBannerClick(jsonQuery);
  }, [jsonQuery]);

  const handleShow = React.useCallback(() => {
    trackMortgageBrokerBannerShow(jsonQuery);
  }, [jsonQuery]);

  return (
    <ActionAfterViewObserver callback={handleShow} percentVisible={0.8} triggerOnce>
      <MortgageBrokerBanner url={url} onClick={handleClick} />
    </ActionAfterViewObserver>
  );
};

MortgageBrokerBannerContainer.displayName = 'MortgageBrokerBannerContainer';
